import { useEffect, useState } from "react";
import { Modal } from "@allaria-tech/matter/Modal";
import { Typography } from "@allaria-tech/matter/Typography";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
import { getUVAIndicator } from "../../connectors/connectors";
import {
  formatPatrimonioThreshold,
  UVA_HERITAGE_THRESHOLD_FORMATTED,
} from "../../utils/uva";

import styles from "./QualifiedInvestorModal.module.scss";

const QualifiedInvestorModal = () => {
  const { content } = styles;

  const dispatch = useAppDispatch();
  const { modalName } = useAppSelector((state) => state.modal);
  const [heritageAmount, setHeritageAmount] = useState<string>();

  const isMobile = window.innerWidth < 768;
  const isOpen = modalName === "modal-qualified-investor";

  const handleClose = () => dispatch(closeModal());

  useEffect(() => {
    if (!isOpen) return;

    const fetchUvaValue = async () => {
      try {
        const { data } = await getUVAIndicator();
        const uvaUnitValue = data.value;

        if (uvaUnitValue) {
          setHeritageAmount(formatPatrimonioThreshold(uvaUnitValue));
        }
      } catch {
        setHeritageAmount(undefined);
      }
    };

    fetchUvaValue();
  }, [isOpen]);

  const patrimonioAmountText = heritageAmount ?? "monto actualizable";

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="¿Qué significa?"
      primaryAction={
        isMobile ? { text: "Volver", onClick: handleClose } : undefined
      }
      footerAlignment="right"
    >
      <div className={content}>
        <Typography type="BODY" size="S">
          De acuerdo con lo establecido en la resolución de la CNV 1097/2025,
          aquellas personas humanas o jurídicas que, por su patrimonio líquido o
          actividad, se encuentren alcanzadas por esta resolución, quedan
          habilitadas para realizar inversiones que conllevan mayores riesgos.
        </Typography>

        <Typography type="BODY" size="S">
          Sujetos institucionales: el Estado Nacional, Provincias, Organismos
          Internacionales, Compañías de Seguros, Agentes de la CNV (actuando por
          cuenta propia) y Fondos Comunes de Inversión.
        </Typography>

        <Typography type="BODY" size="S">
          Patrimonio disponible equivalente a {UVA_HERITAGE_THRESHOLD_FORMATTED}{" "}
          UVAS ({patrimonioAmountText}). Este monto puede estar compuesto por
          valores negociables, depósitos financieros o activos virtuales,
          radicados tanto en Argentina como en el exterior.
        </Typography>
      </div>
    </Modal>
  );
};

export default QualifiedInvestorModal;
